// extracted by mini-css-extract-plugin
export default {"root":"BulkUpdateSyncConfirmModal_root__fLJS7"};